<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" style="width: 20px; height: 20px;" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M4 3.2a5.6 5.6 0 1 1 8 8l-4 4-4-4a5.6 5.6 0 0 1 0-8Zm4 5.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z" clip-rule="evenodd"/></svg>
</template>